import { useTranslation } from 'react-i18next';
import styled from 'styled-components';
import {
  PincoScreen,
  GreenCard,
  PINCO_GREEN,
} from '../components/PincoLayout';

const WarnEmoji = styled.span`
  font-size: 26px;
  line-height: 1;
`;

const WarnCircle = styled.div`
  width: 48px;
  height: 48px;
  flex-shrink: 0;
  display: flex;
  align-items: center;
  justify-content: center;
`;

const WarnRow = styled.div`
  display: flex;
  align-items: flex-start;
  gap: 10px;
`;

const WarnTitle = styled.div`
  margin: 0 0 0 16px;
  font-weight: 400;
  letter-spacing: 0.00938em;
  display: inline-block;
  flex-shrink: 1;
  max-width: calc(100% - 56px);
  text-align: start;
  font-size: 14px;
  font-family: 'PT Mono', monospace;
  line-height: 1.2;
  color: #ffffff;
`;

const RetryBtn = styled.button`
  display: block;
  width: 100%;
  margin: 16px 0 10px;
  padding: 10px 20px;
  background: ${PINCO_GREEN};
  color: #fff;
  border: none;
  border-radius: 8px;
  font-family: 'PT Mono', monospace;
  font-size: 14px;
  font-weight: 600;
  cursor: pointer;
  transition: opacity 0.15s;
  &:hover { opacity: 0.88; }
`;

interface Props {
  onRetry: () => void;
  onBack: () => void;
  uuid?: string;
  timeLeft?: string;
}

const PincoRetryPage = ({ onRetry, onBack, uuid, timeLeft }: Props) => {
  const { t } = useTranslation();

  return (
    <PincoScreen
      uuid={uuid}
      timeLeft={timeLeft}
      actions={[{ label: t('common.back'), onClick: onBack, variant: 'grey' }]}
    >
      <GreenCard>
        <WarnRow>
          <WarnCircle>
            <WarnEmoji>⚠️</WarnEmoji>
          </WarnCircle>
          <WarnTitle>
            {t('waiting.noRequisitesFound')}
          </WarnTitle>
        </WarnRow>
      </GreenCard>

      <RetryBtn onClick={onRetry}>
        {t('waiting.tryAgain')}
      </RetryBtn>
    </PincoScreen>
  );
};

export default PincoRetryPage;
